export const GET_NEW_TAX_REVENUES_GARBAGE =
  'NEW_TAX_REVENUE_GARBAGE/get_new_tax_revenues';
export const GET_SINGLE_NEW_TAX_REVENUES_GARBAGE =
  'NEW_TAX_REVENUE_GARBAGE/get_single_new_tax_revenues';
export const UPDATE_NEW_TAX_REVENUES_GARBAGE =
  'NEW_TAX_REVENUE_GARBAGE/update_new_tax_revenues';
export const CREATE_NEW_TAX_REVENUES_GARBAGE =
  'NEW_TAX_REVENUE_GARBAGE/create_new_tax_revenues';
export const REMOVE_NEW_TAX_REVENUES_GARBAGE =
  'NEW_TAX_REVENUE_GARBAGE/remove_new_tax_revenues';
export const GET_NEW_TAX_REVENUES_TYPE_GARBAGE =
  'NEW_TAX_REVENUE_GARBAGE/get_new_tax_revenues_type';

export const GET_CALCULATIONS_GARBAGE = 'CALCULATIONS_GARBAGE/get_calculations';
export const UPDATE_CALCULATIONS_GARBAGE =
  'CALCULATIONS_GARBAGE/update_calculations';
export const CREATE_CALCULATIONS_GARBAGE =
  'CALCULATIONS_GARBAGE/create_calculations';
export const REMOVE_CALCULATIONS_GARBAGE =
  'CALCULATIONS_GARBAGE/remove_calculations';
export const GET_CALCULATIONS_TYPE_GARBAGE =
  'CALCULATIONS_GARBAGE/get_calculations_type';
export const GET_REPORT_ACCESS = 'CALCULATIONS_GARBAGE/get_report_access';

export const GET_DETAILS_GARBAGE = 'DETAILS_GARBAGE/get_details';
export const UPDATE_DETAILS_GARBAGE = 'DETAILS_GARBAGE/update_details';
export const CREATE_DETAILS_GARBAGE = 'DETAILS_GARBAGE/create_details';
export const REMOVE_DETAILS_GARBAGE = 'DETAILS_GARBAGE/remove_details';

export const FORM_DATA = {
  code: '',
  description: '',
  tax_revenue_type_id: '',
};

export const CALCULATIONS_FORM_DATA = {
  multiplier: '',
  label: '',
  for_new: '',
  for_renewal: '',
  tax_revenue_calculation_type_id: '',
  is_multiple: '',
  with_essential_computation: 0,
  include_for_higher_value_comparison: 0,
  for_retirement: ''
};

export const FORM_DATA_DETAILS = {
  amount: '',
  for_every: '',
  for_every_amount: '',
  from: '',
  to: '',
  rate: '',
  label: '',
  multiplier: '',
  option: '',
  in_excess_of: '',
  for_excess_computation: 0,
  unit: '',
  capacity: ''
};

export const multiplierOption = [
  { label: 'Area', value: 'area' },
  { label: 'No. of Employees', value: 'no_of_employees' },
  { label: 'No. of Male Employees', value: 'no_of_male_employees' },
  { label: 'No. of Female Employees', value: 'no_of_female_employees' },
  { label: 'No. of Employees Residing in Manila', value: 'no_of_employees_residing_manila' },
  { label: 'No. of Vans', value: 'no_of_van' },
  { label: 'No. of Trucks', value: 'no_of_truck' },
  { label: 'No. of Motorcycles', value: 'no_of_motorcycles' },
  { label: 'No. of Vehicles', value: 'no_of_vehicles' },
  { label: 'Location Owned', value: 'location_owned' },
];